import React from "react";
import { ImagePlus, X } from "lucide-react";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export function readImage(file, max = 2 * 1024 * 1024) {
  return new Promise((resolve, reject) => {
    if (!file) return resolve(null);
    if (file.size > max) { toast.error("حجم الصورة يجب أن يكون أقل من 2 ميجابايت"); return resolve(null); }
    const r = new FileReader();
    r.onload = () => resolve(r.result);
    r.onerror = reject;
    r.readAsDataURL(file);
  });
}

export function ExtraImagesPicker({ value = [], onChange, max = 3, label = "صور إضافية تخدم الحملة", hint = "مكان، أجواء، عناصر، تصاميم سابقة — تُستخدم مرجعًا للمشهد", testId = "extra-images" }) {
  const add = async (e) => {
    const files = Array.from(e.target.files || []).slice(0, max - value.length);
    const imgs = (await Promise.all(files.map((f) => readImage(f)))).filter(Boolean);
    if (imgs.length) onChange([...value, ...imgs].slice(0, max));
    e.target.value = "";
  };
  return (
    <div data-testid={testId}>
      <Label className="mb-1 block">{label} <span className="text-xs text-muted-foreground">({value.length}/{max})</span></Label>
      {hint && <p className="text-xs text-muted-foreground mb-2">{hint}</p>}
      <div className="flex flex-wrap gap-2">
        {value.map((src, i) => (
          <div key={i} className="relative w-16 h-16" data-testid={`${testId}-item-${i}`}>
            <img src={src} alt="" className="w-16 h-16 rounded-lg object-cover border border-border" />
            <button type="button" onClick={() => onChange(value.filter((_, idx) => idx !== i))} className="absolute -top-1.5 -start-1.5 bg-destructive text-white rounded-full p-0.5" data-testid={`${testId}-remove-${i}`}><X className="w-3 h-3" /></button>
          </div>
        ))}
        {value.length < max && (
          <label className="cursor-pointer w-16 h-16 rounded-lg border border-dashed border-border bg-secondary flex items-center justify-center text-muted-foreground hover:border-primary/50 transition-colors">
            <input type="file" accept="image/*" multiple className="hidden" onChange={add} data-testid={`${testId}-input`} />
            <ImagePlus className="w-5 h-5" />
          </label>
        )}
      </div>
    </div>
  );
}
